<template>
  <div class="reloanBox">
    <Header :homePage="true" />
    <!-- countdown Box -->
    <div class="countdown">
      <p style="margin-right:0.28rem">
        El orden será inválido hasta
      </p>
      <van-count-down v-show="time" :time="time">
        <template #default="timeData">
          <span class="block">{{
            timeData.hours >= 10 ? timeData.hours : "0" + timeData.hours
          }}</span>
          <span class="colon">:</span>
          <span class="block">{{
            timeData.minutes >= 10 ? timeData.minutes : "0" + timeData.minutes
          }}</span>
          <span class="colon">:</span>
          <span class="block">{{
            timeData.seconds >= 10 ? timeData.seconds : "0" + timeData.seconds
          }}</span>
        </template>
      </van-count-down>
    </div>

    <!-- reloan detail -->
    <div class="reLoanDetail">
      <div class="infoBox">
        <div class="leftInfo">
          <h5>Monto de préstamo</h5>
          <p>S/{{ $setNum(reloanInfo.borrowAmount) }}</p>
        </div>
        <div class="rightInfo">
          <h5>Plazo</h5>
          <p>{{ reloanInfo.period }} días</p>
        </div>
      </div>
      <!-- reloan Btn -->
      <div @click="subfrloan" class="reloanBtn">Applying for a loan</div>
    </div>

    <!-- protocol -->
    <p class="protocolBox">
      Acepto las condiciones del
      <a @click="jumpLoanProtocol">contrato de préstamo</a>
    </p>

    <!-- trial Detail Box -->
    <div class="trialDetail">
      <h3>Detalles del préstamo</h3>
      <ul>
        <li>
          <p>Fecha de vencimiento</p>
          <p>{{ reloanInfo.firstRepayDateFormat }}</p>
        </li>
        <li>
          <p>Monto de depósito</p>
          <p>S/ {{ $setNum(reloanInfo.borrowAmount) }}</p>
        </li>
        <li>
          <p>Monto de pago</p>
          <p>S/ {{ $setNum(reloanInfo.totalRepayAmount) }}</p>
        </li>
        <li @click="openDetil">
          <p>
            Tasa de interés total
          </p>
          <van-icon
            :style="{
              transform: detailShow ? 'rotate(180deg)' : 'rotate(0)',
              transition: 'all .2s',
            }"
            name="arrow-down"
          />
          <!-- <p>S/ {{ totalInterestRate }}</p> -->
        </li>
        <li
          :style="{
            height: detailShow ? '2.2rem' : '0',
            overflow: 'hidden',
            transition: 'all .2s',
            marginBottom: 0,
            background: '#F5F5F5',
            borderRadius: '0.1rem',
            display: 'block',
          }"
        >
          <ul class="childList">
            <li>
              <p>Interés</p>
              <p>S/ {{ $setNum(reloanInfo.totalInterest) }}</p>
            </li>
            <li>
              <p>Cargo de servicios</p>
              <p>S/ {{ $setNum(reloanInfo.totalServiceFee) }}</p>
            </li>
            <li>
              <p>IGV</p>
              <p>S/ {{ $setNum(reloanInfo.totalGst) }}</p>
            </li>
          </ul>
        </li>
      </ul>
    </div>

    <ContactOrAbout />
  </div>
</template>

<script>
import Header from "./components/header.vue";
import ContactOrAbout from "./components/contactOrAbout.vue";
import { orderCalculate, loanConfirm } from "../utils/api/h5page.js";
export default {
  name: "",
  components: {
    Header,
    ContactOrAbout,
  },
  props: {
    userInfo: {
      type: Object,
    },
  },
  data() {
    return {
      detailShow: false,
      time: 0,
      reloanInfo: {
        period: 0,
        server_time: "",
        borrowAmount: "",
        totalRepayAmount: "",
        totalInterest: "",
        totalServiceFee: "",
        totalGst: "",
        firstRepayDateFormat: "",
      },
      jsonObj: {},
    };
  },
  computed: {},
  watch: {},
  created() {},
  mounted() {
    orderCalculate({
      accountCouponId: "-1",
      borrowAmount: this.userInfo.loan_amount,
    }).then(({ data }) => {
      this.time = data.data.expireMillion;
      this.loanData = data.data;
      for (let i in data.data) {
        for (let row in this.reloanInfo) {
          if (row == i) {
            this.reloanInfo[row] = data.data[i];
          }
        }
      }
    });
  },
  methods: {
    // submit reLoan
    subfrloan() {
      const params = {
        coupon_id: "-1",
        borrowAmount: this.reloanInfo.borrowAmount,
      };
      loanConfirm(params).then(({ data }) => {
        console.log("[ data ] >", data);
        if (data.code == 0) {
          this.$emit("getUserInformation");
        }
      });
    },

    // catch loan detail
    openDetil() {
      this.detailShow = !this.detailShow;
    },

    jumpLoanProtocol() {
      let urlparams = encodeURIComponent(JSON.stringify(this.loanData));
      if (window.location.host == "www.credisol.pe") {
        window.open(
          "https://www.credisol.pe/h5/loan.html?userInfo=" + urlparams
        );
      } else {
        window.open(
          "https://credisol.jinglewill.com/1822874325/h5/loan.html?userInfo=" +
            urlparams
        );
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.reloanBox {
  padding: 0 0.2rem 0.2rem;
  background-color: #f5f5f5;
}

.countdown {
  display: flex;
  justify-content: center;
  align-items: center;
  font-family: Roboto, Roboto;
  font-weight: 400;
  font-size: 0.23rem;
  color: #666666;
  padding: 0.2rem 0 0.32rem;
  .colon {
    display: inline-block;
    margin: 0 0.16rem;
    color: #dddddd;
  }
  .block {
    display: inline-block;
    width: 0.45rem;
    height: 0.45rem;
    line-height: 0.45rem;
    color: #fff;
    font-family: Roboto, Roboto;
    font-weight: 400;
    font-size: 0.26rem;
    text-align: center;
    border-radius: 0.08rem;
    background-color: #ffd347;
  }
}

.reLoanDetail {
  width: 100%;
  padding: 0.7rem 0.5rem 0.4rem;
  background: #c90000;
  border-radius: 0.2rem;
  .infoBox {
    display: flex;
    justify-content: space-between;
    margin-bottom: 0.69rem;
    h5 {
      font-family: Roboto, Roboto;
      font-weight: 400;
      font-size: 0.28rem;
      color: #ffffff;
      margin-bottom: 0.3rem;
    }
    p {
      font-family: Roboto, Roboto;
      font-weight: 500;
      font-size: 0.5rem;
      color: #ffffff;
    }
  }

  .reloanBtn {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 5.8rem;
    height: 0.8rem;
    background: #ffffff;
    box-shadow: inset 0rem 0.16rem 0.32rem 0rem rgba(255, 255, 255, 0.22);
    border-radius: 0.4rem;
    font-family: PingFangSC, PingFang SC;
    font-weight: 700;
    font-size: 0.32rem;
    color: #333333;
  }
}

.trialDetail {
  width: 100%;
  background: #ffffff;
  border-radius: 0.2rem;
  padding: 0.34rem 0.24rem;
  margin: 0.3rem 0 0.17rem;
  h3 {
    font-family: Roboto, Roboto;
    font-weight: 700;
    font-size: 0.32rem;
    color: #333333;
    margin-bottom: 0.4rem;
  }
  ul {
    li {
      display: flex;
      justify-content: space-between;
      margin-bottom: 0.3rem;
      p {
        font-family: Roboto, Roboto;
        font-weight: 400;
        font-size: 0.26rem;
        color: #333333;
      }
      .van-icon-arrow-down {
        font-size: 0.32rem;
      }
      .childList {
        padding: 0.31rem 0.24rem;
        li {
          p {
            font-family: Roboto, Roboto;
            font-weight: 400;
            font-size: 0.24rem;
            color: #666666;
          }
          &:last-child {
            margin: 0;
          }
        }
      }
    }
  }
}

.protocolBox {
  font-family: Roboto, Roboto;
  font-weight: 400;
  font-size: 0.22rem;
  color: #999999;
  text-align: center;
  margin-top: 0.3rem;
  a {
    color: #333333;
    text-decoration: underline;
  }
}
</style>
